import { get } from '../../utils/object-helpers';
import { sendSortListingsEvent } from '../../utils/event-triggers';

export default {
    onCreate(input) {
        this.setData(input);
    },
    onInput(input) {
        this.setData(input); // Need to reset properties when ajaxUpdate inputs new data.
    },
    setData(data) {
        const options = get(data, 'sortItemsSelection.options', []);
        const selectedOption = options.find(opt => opt.selected);
        this.tabName = data.tabName;
        this.state = {
            options: options,
            selectedText: selectedOption && selectedOption.text
        };
    },
    updateState(data) {
        this.state.options.forEach((option, idx) => {
            option.selected = data.checked[0] === idx;
            if (option.selected) {
                this.state.selectedText = option.text;
            }
        });
        this.setStateDirty('options');
    },
    sortListings(data) {
        const previousState = JSON.parse(JSON.stringify(this.state));
        this.updateState(data);
        const dataUrl = JSON.parse(get(data, 'el.dataset.url', ''));
        sendSortListingsEvent({
            url: dataUrl,
            tabName: this.tabName,
            errorCallback: () => {
                // Revert the menu if error
                this.state.options = previousState.options;
                this.state.selectedText = previousState.selectedText;
                this.setStateDirty('options');
            }
        });
    }
};
